<div class="layout-row align-end gap-2px responsive-column container m-b-20">
  <button mat-raised-button color="primary" [routerLink]="['edit']" *LOSxHasPermission="'UPDATE_CRITERIA'">
    <fa-icon icon="edit" class="m-r-10"></fa-icon>
    {{ 'labels.buttons.Edit' | translate }}
  </button>
  <button mat-raised-button color="warn" (click)="deleteCriteria()" *LOSxHasPermission="'DELETE_CRITERIA'">
    <fa-icon icon="trash" class="m-r-10"></fa-icon>
    {{ 'labels.buttons.Delete' | translate }}
  </button>
</div>

<div class="container">
  <mat-card>
    <mat-card-content>
      <div class="layout-row-wrap align-center">
        <h2 class="mat-h2 criteria-title">
          {{ provisioningData.criteriaName }}
        </h2>
        <span class="loan-product-label">
          <strong>{{ 'labels.inputs.Loan Product' | translate }}:</strong>
          <span>{{ loanProducts }}</span>
        </span>
      </div>
      <mat-divider [inset]="true"></mat-divider>

      <div>
        <table mat-table class="mat-elevation-z1" [dataSource]="dataSource">
          <ng-container matColumnDef="category">
            <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Category' | translate }}</th>
            <td mat-cell *matCellDef="let provisioningData">{{ provisioningData.categoryName }}</td>
          </ng-container>

          <ng-container matColumnDef="minAge">
            <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Min Age' | translate }}</th>
            <td mat-cell *matCellDef="let provisioningData">{{ provisioningData.minAge }}</td>
          </ng-container>

          <ng-container matColumnDef="maxAge">
            <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Max Age' | translate }}</th>
            <td mat-cell *matCellDef="let provisioningData">{{ provisioningData.maxAge }}</td>
          </ng-container>

          <ng-container matColumnDef="percentage">
            <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Percentage' | translate }}</th>
            <td mat-cell *matCellDef="let provisioningData">{{ provisioningData.provisioningPercentage }}</td>
          </ng-container>

          <ng-container matColumnDef="liabilityAccount">
            <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Liability Account' | translate }}</th>
            <td mat-cell *matCellDef="let provisioningData">{{ provisioningData.liabilityName }}</td>
          </ng-container>

          <ng-container matColumnDef="expenseAccount">
            <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Expense Account' | translate }}</th>
            <td mat-cell *matCellDef="let provisioningData">{{ provisioningData.expenseName }}</td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>
    </mat-card-content>
  </mat-card>
</div>
